import { sortRundownItems } from '../../../functions/sortRundownItems'
import { removeElement } from '../../../functions/dom.js'

class ItemPlannerBlock {

    constructor ($scope, $rootScope, $http, selector) {
        this.shouldOpenBroadcastBlocks = this.shouldOpenBroadcastBlocks.bind(this)
        this.removeItemWhenFound = this.removeItemWhenFound.bind(this)
        this.moveSelection = this.moveSelection.bind(this)

        this.$scope = $scope
        this.$rootScope = $rootScope
        this.$http = $http
        this.selector = selector

        this.sortItemsDebounce = _.debounce(() => {
            $scope.$applyAsync(() => {
                $scope.block.items = sortRundownItems($scope.block.items)
            })
        }, 500)

        const blockId = $scope.block.id
        $scope.$on('item-planner_show-broadcast', this.shouldOpenBroadcastBlocks)
        $scope.$on('item-planner_remove-item_block_' + blockId, this.removeItemWhenFound)
        $scope.$on('item-planner_move-item-to-block_' + blockId, this.moveSelection)
        $scope.$on('item-planner_sort-block_' + blockId, this.sortItemsDebounce)
    }

    removeItemWhenFound (event, item) {
        const { $scope } = this

        $scope.$applyAsync(() => {
            const blockItems = $scope.block.items
            const index = _.findIndex(blockItems, { id: item.id })

            if (index !== -1) {
                blockItems.splice(index, 1)
            }
        })
    }

    shouldOpenBroadcastBlocks (event, broadcastId) {
        const { $scope } = this

        $scope.$applyAsync(() => {
            $scope.showBlock = $scope.block.broadcast_id === broadcastId
            if (!$scope.showBlock) $scope.mouseOverBlock = false
        })
    }

    moveItemToThisBlock (savedItem, options) {

        const { $rootScope, $scope } = this

        const block = $scope.block
        const blockItems = block.items
        let copy
        if (options.copyToNewItem !== undefined) {
            copy = options.copyToNewItem
        } else {
            copy = false
        }

        const oldItem = $scope.block.items.find(item => item.id == savedItem.id) || {}
        const movedOutOfBlock = oldItem.block_id != savedItem.block_id

        if (movedOutOfBlock) {
            $rootScope.$broadcast('item-planner_remove-item_block_' + oldItem.block_id, savedItem)
        }

        $rootScope.$broadcast('item-planner_item_saved', !copy, savedItem)

        if (movedOutOfBlock) {
            blockItems.push(savedItem)
        } else {
            Object.assign(oldItem, savedItem)
        }

        this.sortItemsDebounce()
    }

    moveSelection (event, options) {
        this.moveSelectionToThisBlock(options)
    }

    moveSelectionToThisBlock (extraOptions = {}) {
        const { $http, $scope, selector } = this

        const blockId = $scope.block.id
        const itemIdsSelection = selector.getSelectionIds()
        const relations = `with[]=contacts&with[]=campaign.modelType&with[]=tags`

        if (itemIdsSelection.length === 1) {
            return $http.patch(`items/${encodeURIComponent(itemIdsSelection[0])}?${relations}`, {
                block_id: blockId,
                ...extraOptions,
            }).then()
            // .then(result => {
            //     this.moveItemToThisBlock(result.data, extraOptions);
            // });
        }

        const data = {}

        const orderIsZero = extraOptions.order

        for (const itemId of itemIdsSelection) {
            if (orderIsZero) {
                extraOptions.order += .0001
            }

            data[itemId] = {
                block_id: blockId,
                ...extraOptions,
            }
        }

        return $http.patch(`/items/bulk?${relations}`, data).then()
        // .then(result => {
        //     for (const data of result.data.updatedItems) {
        //         this.moveItemToThisBlock(data, extraOptions);
        //     }
        // });

    }

    onMouseOverBlock () {
        if (this.timer) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            const { $rootScope, $scope } = this
            const blockId = $scope.block.id

            if ($rootScope.itemPlannerInCopyState) {
                $scope.$applyAsync(() => {
                    $scope.mouseOverBlock = true
                    if ($rootScope.itemPlannerHoverBlock !== blockId) {
                        $rootScope.itemPlannerHoverBlock = blockId
                    }
                })
            }
        }, 0) // you need 0 milisec delay to stop the jumping
    }

    onMouseLeaveBlock () {
        if (this.timer) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            const { $rootScope, $scope } = this
            const blockId = $scope.block.id

            if ($rootScope.itemPlannerInCopyState || $scope.mouseOverBlock) {
                $scope.$applyAsync(() => {
                    $scope.mouseOverBlock = false

                    if ($rootScope.itemPlannerHoverBlock === blockId) {
                        $rootScope.itemPlannerHoverBlock = null
                    }
                })
            }
        }, 0) // you need 0 milisec delay to stop the jumping
    }

    onItemDrop (event, index) {
        dndCleanupFix('.ItemPlanner-Broadcasts-Content')

        const { $scope, selector } = this

        const options = {}

        if (event.ctrlKey || event.altKey) {
            options.copyToNewItem = true
        }

        if (index === 0) {
            options.order = index
        } else {
            const blockItems = $scope.block.items
            const beforeItem = blockItems[index - 1]
            if (beforeItem) {
                options.afterItemId = beforeItem.id
            } else {
                options.placeOnEndOfBlock = true
            }
        }

        this.moveSelectionToThisBlock(options)
        selector.clearSelection()

        setTimeout(() => {
            // @todo clean all dnd placeholders
        })
    }

    openBroadcastBlocks () {
        const { $scope, $rootScope } = this
        const broadcastId = $scope.block.broadcast_id

        if ($rootScope.itemPlannerCurrentBroadcast !== broadcastId) {
            $rootScope.itemPlannerCurrentBroadcast = broadcastId
            $rootScope.$broadcast('item-planner_show-broadcast', broadcastId)
        }

        return true
    }

}

export default [() => {
    return {
        templateUrl: '/partial/app.partials.item-planner.directives.block',
        replace: true,
        controller: [
            '$scope',
            '$rootScope',
            '$http',
            'itemPlannerSelection',
            ItemPlannerBlock,
        ],
        controllerAs: 'ctrl',
        scope: {
            block: '=',
            broadcast: '=',
        },
    }
}]
